import instance from "../../services/api";

export const reportCostOfPayment = (params = {}) => {
  return instance(true).post(
    "/partner/report_costs_of_payment_by_dates/",
    params
  );
};
